<template>
  <!-- `lew-logo` is not styling: it is what lifts the mark out of Sentry's blockAllMedia, which
       otherwise replaces every image in a replay with a grey box. See plugins/sentry.js. -->
  <img :src="logo" :height="height" :width="width" class="lew-logo" />
</template>

<script>
export default {
  name: "LewLogo",
  props: {
    height: [Number, String],
    width: [Number, String],
    vertical: {
      type: Boolean,
      default: false,
    },
    // Renders just the diamond mark, without the (white) "Lewara" wordmark.
    icon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    let logo
    if (props.icon) {
      logo = new URL("@/assets/logo_icon.svg", import.meta.url).href
    } else if (props.vertical) {
      logo = new URL("@/assets/logo_vertical.svg", import.meta.url).href
    } else {
      logo = new URL("@/assets/logo_horizontal.svg", import.meta.url).href
    }
    return { logo }
  },
}
</script>

<style scoped></style>
